import { render, staticRenderFns } from "./PointListEarn.vue?vue&type=template&id=58411f28&scoped=true&"
import script from "./PointListEarn.vue?vue&type=script&lang=js&"
export * from "./PointListEarn.vue?vue&type=script&lang=js&"
import style0 from "./PointListEarn.vue?vue&type=style&index=0&id=58411f28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58411f28",
  null
  
)

export default component.exports